import * as APPOINTMENT from '@/store/constants/appointment';
import {mapActions} from 'vuex';

export default {
  props: {
    patient: {
      type: Object
    }
  },
  data() {
    return {
      fields: [
        'doctor',
        'appointment_date',
        'notes',
        'action'
      ],
      appointments: []
    }
  },

  methods: {
    ...mapActions({
      getAppointments: APPOINTMENT.ACTION_LIST_APPOINTMENTS,
    }),

    viewDetail(data) {
      this.$router.push(
        {
          name: 'AppointmentDetail',
          params: {id: data.id, appointment: data}
        }
      );
    },

    handleGetAppointment(id) {
      this.getAppointments({
        filter: [`patient_id,=,${id}`]
      }).then((res) => {
        this.appointments = res.data;
      });
    },
  },

  mounted() {
    this.handleGetAppointment(this.$route.params['id']);
  }
}



// WEBPACK FOOTER //
// ./src/views/Patient/Detail/InformationTab/js/appointment-tab.js